import React, { ReactElement, useState } from "react"
import { useLocation, useParams } from "react-router-dom"

import { Loading, Modal } from "@wfp/ui"

import { useGetReportDataQuery } from "../../services/marketprices/reports"

import { ReportTableData } from "../../interfaces/dataInterfaces"

import ReportTable from "../../components/Reports/ReportTable"
import ReportDataDetails from "../../components/Reports/ReportDataDetails"
import DataReviewPage from "../Markets/DataReviewPage"

const ReportPage = (): ReactElement => {
  const { rId } = useParams()
  const { hash } = useLocation()

  const [showDetails, setShowDetails] = useState<ReportTableData | null>(null)

  const { data: reportRows, isFetching: isLoadingReport } = useGetReportDataQuery(Number(rId), {
    skip: !rId,
    refetchOnMountOrArgChange: true,
  })

  if (isLoadingReport)
    return (
      <div className="flex align-center justify-center min-h-[50vh]">
        <Loading withOverlay={false} small />
      </div>
    )

  if (hash === "#review") return <DataReviewPage />

  return (
    <>
      <div className="mt-2">
        <ReportTable data={reportRows} setShowDetails={setShowDetails} tableHeight="calc(100vh - 200px)" />
      </div>

      <Modal open={!!showDetails} modalHeading="Details" passiveModal onRequestClose={() => setShowDetails(null)}>
        <ReportDataDetails showDetails={showDetails} />
      </Modal>
    </>
  )
}

export default ReportPage
